import { useEffect, useState } from "react";
import { TextField, TextFieldProps } from "@mui/material";

export type ManagedTextAreaFieldProps = TextFieldProps & {
	value: string;
	onUpdate: (value: string) => void;
};

// DEPRECATED: this is a bad component.
// @deprecated
const ManagedTextArea: React.FC<ManagedTextAreaFieldProps> = (
	props: ManagedTextAreaFieldProps
) => {
	const [value, setValue] = useState(props.value);

	useEffect(() => setValue(props.value), [props.value]);

	function handleBlur(e: React.FocusEvent<HTMLInputElement>): void {
		const value = e.target.value.trim();
		setValue(value)
		if (value !== props.value) {
			props.onUpdate(value);
		}
	}

	return (
		<TextField
			multiline
			autoFocus={props.autoFocus}
			value={value}
			label={props.label}
			disabled={props.disabled}
			error={props.error}
			fullWidth={props.fullWidth}
			type={props.type}
			variant={props.variant}
			minRows={props.minRows}
			onBlur={handleBlur}
			onChange={e => setValue(e.target.value)}
		/>
	);
};

export default ManagedTextArea;
